import { Component, OnInit, Input, ViewChild, TemplateRef, Output, EventEmitter, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import * as _ from 'lodash';
import * as moment from 'moment';

import { AdvanceReturnService, CommonService, SubscribeService } from '../../../services/index';
import { ServiceWalkInModel } from '../../../model/index';
//import { clientOutComponent } from '../../common/clientOut.component';

@Component({
    selector: 'advance-return-tab',
    templateUrl: './advanceReturn.component.html'
})
export class AdvanceReturnComponent implements OnInit {

    isLoadMask: Promise<any>;
    serviceWalkInData: ServiceWalkInModel[];
    loadingIndicator: boolean = true;
    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'bill_id',
        orderDir: 'asc'
    };
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;
    statusCusCtrl: FormControl;
    columns = [];
    toggleCol = [];
    filterData = {
        "search_data": "",
        "from_date":new Date(),
        "to_date": new Date(),
    };
    scrollTimeout: any;
    suppressPaging: boolean = false;
    constructor(public toasterService: ToasterService, private advanceReturnService: AdvanceReturnService, public subscribeService: SubscribeService, private modalService: BsModalService) {
        this.statusCusCtrl = new FormControl();
    }

    ngOnInit(): void {
        let that = this;
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 50, minWidth: 50, maxWidth: 50, sortable: false, cellClass: 'cell-center', cellTemplate: this.snoTemplate, toggle: true },
            { name: 'Return No', prop: 'auto_no', width: 100, minWidth: 100, maxWidth: 100, toggle: true },
            { name: 'Return Date', prop: 'disp_return_date', width: 120, minWidth: 120, maxWidth: 120, toggle: true },
            { name: 'Client Name', prop: 'client_name', width: 210, minWidth: 210, maxWidth: 210 },
            { name: 'Description', prop: 'description', width: 280, minWidth: 280, maxWidth: 280 },
            { name: 'Mobile', prop: 'mobile', width: 150, minWidth: 150, maxWidth: 150, },
            { name: 'Action', prop: 'action', width: 80, minWidth: 80, maxWidth: 80, sortable: false, cellClass: 'cell-left', cellTemplate: this.editDeleteTemplate }
        ];



        this.toggleCol = Object.assign({}, this.columns);
        this.pageCallback({ offset: 0 });

        this.subscribeService.publishReloadClientWalkInGrid().subscribe(($e) => {
            that.pageCallback({ offset: 0 });
        });

        this.subscribeService.publishReloadServiceGrid().subscribe(($e) => {
            that.pageCallback({ offset: 0 });
        })
    }
    ngOnDestroy() {
        // prevent memory leak when component destroyed
        //this.subscribeService.publishReloadClientWalkInGrid().unsubscribe();
    }
    onOpenedFilter(): void {
        setTimeout(function () {
            $('#filterTextBox').focus();
        }, 100);

    }

    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getAdvanceReturnList();
    }

    onColumnToggle(colToShow) {
        this.columns = colToShow;
    }


    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (!this.suppressPaging) {
            this.page.offset = pageInfo.offset;
            this.getAdvanceReturnList();
        }
    }
    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) {
            //celarTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 1000)
    }
    clearFilter(): void {
        this.filterData = {
            "search_data": "",
            "from_date": new Date(),
            "to_date": new Date(),

        };
        this.applyFilter();
    }
    applyFilter(): void {
        //this.filterExpand = false;
        this.filterPanel.close();
        this.getAdvanceReturnList();
    }
    getAdvanceReturnList(): void {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            //filter: JSON.stringify(this.filterData),search_data
            search_data: this.filterData['search_data'],
            from_date: moment(this.filterData['from_date']).format('YYYY-MM-DD'),
            to_date: moment(this.filterData['to_date']).format('YYYY-MM-DD'),
            //view_type: this.filterData['view_type'],
            from_page: this['params']['tabParams']
        };
        let that = this;
        //this.store.dispatch(new commonActions.LoadAllSku(params));
        this.isLoadMask = this.advanceReturnService
            .getAdvanceReturnList(params)
            .then(function (res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.serviceWalkInData = res.data;
            });
    }

    addEditSalesReturn(mode: string, row: any): void {
        let that = this;
        setTimeout(function () {
            that.filterPanel.close();
        }, 10);

        if (mode == "Add") {
            row = {
                'bill_id': '',
                mode: mode
            };
        } else if (mode == "Edit") {
            row['mode'] = mode;
        }

        that.subscribeService.subScribeTabID('Transaction', 'AddAdvanceReturnComponent', Object.assign({}, row), this['params']['tabParams']);

    }

    deleteAdvanceReturn(row: any): void {

        let that = this,
            data = {
                bill_id: row.bill_id,
                advance_bill_id: row.advance_bill_id,
                client_id: row.client_id,
                salesItemDetails: JSON.stringify(row.data),
                type: row.type
            };
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover this Advance Return Details of [' + row['client_no'] + '-' + row['client_name'] + ']',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function () {
            that.isLoadMask = that.advanceReturnService
                .deleteAdvanceReturn(data)
                .then(function (res: any) {
                    that.loadingIndicator = false;
                    if (res.success) {
                        that.getAdvanceReturnList();
                        swal(
                            'Deleted',
                            res.message,
                            'success'
                        );
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }
                });

        }, function (dismiss) {

        })
    }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/advanceReturn/advanceReturn.component.ts